module.exports = __webpack_public_path__ + "media/images/official-1-c2ccfbe14affb80244b521710dcfaaef.png";